var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.saison)?_c('span',[_c('confirm-dialog',{attrs:{"open":_vm.confirmDelete.open,"header":_vm.confirmDelete.header,"question":_vm.confirmDelete.question,"query-parameter":'confirmSpielPlanDelete'+_vm.saison.id},on:{"reply":_vm.processConfirm}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }